import { FC, useCallback, useMemo } from 'react';
import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
import type { OtcClient } from 'state/secondaryMarket/shared/referential/referential.model';

import { htmlDecode } from '../../../utils/html-decode';
import type { SearchResultItemProps } from '../compact-selector/utils';
import { searchedTextInBold } from '../compact-selector/utils';

export const OtcSearchResultItem: FC<SearchResultItemProps<OtcClient>> = ({
  item,
  onSelected,
  isSelected,
  searchedText,
}) => {
  const onClick = useCallback(() => onSelected(item), [onSelected, item]);
  const { label, eliotCode } = item;
  const decodedLabel = useMemo(() => htmlDecode(label), [label]);

  return (
    <ScrollIntoViewIfNeeded
      active={isSelected}
      elementType="tr"
      data-e2e="client-search-item"
      className={isSelected ? 'table-active' : undefined}
      onClick={onClick}
    >
      <td data-e2e="client-origin">
        <i className="icon icon-sm">close</i>
      </td>
      <td className="text-truncate" data-e2e="client-label">
        {searchedTextInBold(decodedLabel, searchedText)}
      </td>
      <td data-e2e="client-eliot-code">{eliotCode ? searchedTextInBold(eliotCode, searchedText) : ''}</td>
    </ScrollIntoViewIfNeeded>
  );
};

OtcSearchResultItem.displayName = 'OtcSearchResultItem';
